<template>
  <div class="sf-view sf-form">
    <loading v-if="loadingRender"></loading>

    <div v-if="ErrorList && ErrorList.length > 0" class="sf-notice sf-notice--danger">
      <i class="fas fa-exclamation-circle"></i>
      <ul>
        <li v-for="(error, index) in ErrorList" :key="index">{{ error.message }}</li>
      </ul>
    </div>

    <section class="sf-section">
      <h6 class="sf-section__title"><i class="fas fa-file-invoice-dollar"></i> مشخصات سفته</h6>
      <div class="sf-grid">
        <div class="sf-field sf-field--third">
          <label for="safte_amount">مبلغ سفته ({{ $GetVahedPool() }})</label>
          <input id="safte_amount" type="text" @keypress="$ValidNumber($event, 16)" @keyup="$PutCommatoInput()" v-model="DataAxios.amount" dir="ltr" class="form-control 3ragham" />
          <span class="sf-hint sf-hint--accent">{{ Mab2persian() }}</span>
        </div>
        <div class="sf-field sf-field--third">
          <label for="safte_due_date">تاریخ صدور</label>
          <date-picker :editable="true" :auto-submit="true" color="rgb(94 163 30)" v-model="DataAxios.due_date"> </date-picker>
        </div>
        <div class="sf-field sf-field--third">
          <label for="safte_description">شرح سفته</label>
          <input id="safte_description" type="text" v-model="DataAxios.description" class="form-control" />
        </div>
      </div>
    </section>

    <section class="sf-section">
      <h6 class="sf-section__title"><i class="fas fa-user-tie"></i> مشخصات صاحب سفته</h6>
      <div class="sf-grid">
        <div class="sf-field sf-field--third">
          <label for="issuer_full_name">نام صاحب سفته</label>
          <input id="issuer_full_name" type="text" v-model="DataAxios.issuer_full_name" class="form-control" />
        </div>
        <div class="sf-field sf-field--third">
          <label for="issuer_national_code">کد ملی</label>
          <input id="issuer_national_code" type="text" @keypress="$ValidNumber($event, 10)" dir="ltr" v-model="DataAxios.issuer_national_code" class="form-control" />
        </div>
        <div class="sf-field sf-field--third">
          <label for="issuer_account_number">شماره حساب</label>
          <input id="issuer_account_number" type="text" @keypress="$ValidNumber($event, 20)" dir="ltr" v-model="DataAxios.issuer_account_number" class="form-control" />
        </div>
        <div class="sf-field sf-field--third">
          <label for="issuer_mobile_number">شماره همراه</label>
          <input id="issuer_mobile_number" type="text" @keypress="$ValidNumber($event, 11)" dir="ltr" v-model="DataAxios.issuer_mobile_number" class="form-control" />
        </div>
        <div class="sf-field sf-field--third">
          <label for="issuer_postal_code">کد پستی</label>
          <input id="issuer_postal_code" type="text" v-model="DataAxios.issuer_postal_code" @keypress="$ValidNumber($event, 10)" dir="ltr" class="form-control" />
        </div>
        <div class="sf-field sf-field--third">
          <label for="issuer_address">آدرس</label>
          <input id="issuer_address" type="text" v-model="DataAxios.issuer_address" class="form-control" />
        </div>
      </div>
    </section>

    <div class="sf-actions">
      <button type="button" class="sf-btn sf-btn--secondary" @click="$emit('cancel')">انصراف</button>
      <button type="button" class="sf-btn sf-btn--primary" :disabled="disableButton" @click="Submitrequest">ثبت درخواست</button>
    </div>
  </div>
</template><script>
import Loading from '../../Tools/NetPa/Loading.vue'
import Num2persian from 'num2persian'

export default {
  components: { Loading },
  data() {
    return {
      loadingRender: null,
      ErrorList: null,
      disableButton: false,
      DataAxios: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        amount: 0,
        description: '',
        due_date: '',
        issuer_account_number: '',
        issuer_address: '',
        issuer_full_name: '',
        issuer_mobile_number: '',
        issuer_national_code: '',
        issuer_postal_code: '',
        issuer_is_legal: 'false',
        recipient_national_code: '',
      },
    }
  },
  props: ['Data'],
  methods: {
    Submitrequest() {
      this.loadingRender = true
      this.DataAxios.amount = this.DataAxios.amount + ''
      this.DataAxios.amount = Number(this.DataAxios.amount.replace(/,/g, '').replace(/\./g, ''))
      this.DataAxios.due_date = this.DataAxios.due_date.replace(/\//g, '').replace(/\./g, '')
      this.DataAxios.issuer_national_code = this.DataAxios.issuer_national_code.trim()
      var DataAxios = { method: 'POST', action: 'ElectronicSafte/Safte_Receive', arryfildValue: this.DataAxios }
      this.$PostData_netpatoken(DataAxios)
        .then((result) => {
          if (result.status == 'success') {
            this.loadingRender = false
            this.$mySweetDefaultTost('عملیات موفق', 'سفته با موفقیت ثبت شد لطفا اطلاعات روی سفته را بررسی کنید', 'success', 3000)
            this.$emit('SafteRecieved', result.data)
          } else {
            this.loadingRender = false
            this.ErrorList = result.data
          }
        })
        .finally((data) => {
          this.loadingRender = false
        })
    },
    Mab2persian() {
      var string = this.DataAxios.amount + ''
      var Mab = string.replace(/,/g, '')
      Mab = this.$b_ToPersianNumber(Mab)
      // Mab=Mab/10
      const words = Num2persian(Mab)
      return words ? words + ' ' + this.$GetVahedPool() : ''
    },
  },
  created() {
    this.DataAxios.issuer_is_legal = false
    this.DataAxios.due_date = this.$GetJalaliDateTime()
  },
}
</script>
